"use client";

import { useCallback, useState } from "react";
import type { RecordViewDraft } from "./types";

export function useRecordTableDialogs() {
  const [columnsOpen, setColumnsOpen] = useState(false);
  const [saveOpen, setSaveOpen] = useState(false);
  const [saveDraft, setSaveDraft] = useState<RecordViewDraft | null>(null);
  const openSaveDialog = useCallback((draft?: RecordViewDraft) => {
    setSaveDraft(draft ?? null);
    setSaveOpen(true);
  }, []);
  return {
    columnsOpen,
    setColumnsOpen,
    saveOpen,
    setSaveOpen,
    saveDraft,
    openSaveDialog,
  };
}

export type RecordTableDialogsState = ReturnType<typeof useRecordTableDialogs>;
